import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { createLabelAugmentation } from './createLabelAugmentation';
import { editLabelAugmentation } from './editLabelAugmentation';

export const workflows: WorkflowOptions[] = [
  createLabelAugmentation,
  editLabelAugmentation,
  ...Object.values(generateAssetStatusWorkflow('labelAugmentation')),
];

export default workflows;
